













































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {DiaDisinfect,GetDiaDisinfect,GetDiaDisinfects} from '../../../api/dialysisProcess'

import {GetListByCode} from '../../../api/configureDictionary/'


@Component({
    components:{}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    //左右tabs
    tabsShow = 1

    form:any = {
        machineID:this.data.machineID,
        shift:null,
        disinfectSt:new Date(),
        disinfectEnd:new Date(),
        disinfectType:null,
        jnxdj:null,
        isJwxd:'是',
        outDisinfectSt:new Date(),
        jwxdj:null,
        changeGlq:null,
        changeXdy:null,
        remarks:null,
    }
    list:any = []
    //写死
    disinfectTypes = ['热消毒','柠檬消毒','化学消毒','其他消毒','高温消毒']
    jnxdjs = ['5%次氯酸钠','20%柠檬酸','50%柠檬酸','C棒','A棒','C棒+A棒','机外酒精擦拭','高温消毒','20%柠檬酸+5%次氯酸钠','0.2%季铵盐湿巾纸']
    created() {
        this.getDiaDisinfect()
        this.getData()
    }
    machineInfo:any = {}
    //加载
    async getDiaDisinfect(){
        let data = {
            MachineId:this.data.machineID,
        }
        let res= await GetDiaDisinfect(data)
        this.machineInfo = res.objects;
    }
    async save(){
        let res = await DiaDisinfect(this.form)
        if(res.status==1){
            this.$emit('on-back')
            this.$emit('input',false);
        }
    }
    async getData(){
        let res = await GetDiaDisinfects({})
        this.list = res.objects
    }

    //登陆人
    get userName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisDisinfect.vue